<template>
  <div class="error-box">
    <img src="@/assets/img/500.png" class="img-fluid" alt="Unexpected error" />
    <h3 class="error-500">Unexpected error</h3>
    <div class="back-button">
      <router-link to="/home/" class="btn btn-primary">Back to Home</router-link>
    </div>
  </div>
</template>
